module.exports = __webpack_public_path__ + "static/media/close-quote.04fdb4e7.svg";